import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M21 5v14l-8 -7l8 -7","key":"svg-0"}],["path",{"d":"M10 5v14l-8 -7l8 -7","key":"svg-1"}]]

const IconPlayerTrackPrev = createReactComponent('outline', 'player-track-prev', 'PlayerTrackPrev', __iconNode);

export default IconPlayerTrackPrev;